// extracted by mini-css-extract-plugin
export default {"root":"ZBgzc7GqWa","icon":"Lf8ryVw_sT","name":"GGdLGwt6dX","appIcon":"R0mBwFs7Tr","appIcon_selected":"Ei5AruTqfs"};